export const handleAddOnChange = (value) => {
  const initialValues = {};
  if (!value) return initialValues;
  Object.keys(value).forEach((key) => {
    if (typeof value[key] === "object") {
      // handle values like [1,"name"]
      if (
        typeof value?.[key]?.[0] === "number" &&
        typeof value?.[key]?.[1] === "string"
      ) {
        initialValues[key] = value[key][0];
        return;
      }

      //   handle values like [[5],[4,1,2,3]]

      if (
        typeof value?.[key]?.[0] === "object" &&
        typeof value?.[key]?.[1] === "object"
      ) {
        initialValues[key] = [value[key][1][value[key][1].length - 1]];
        return;
      }
      initialValues[key] = [];
      return;
    }
    initialValues[key] = value[key];
    return;
  });
  return initialValues;
};
